import api from "./api";

export default class SystemApi {

    // static getIpAddress = async () => {
    //     // try {
    //     //     const response = await api.get(`https://api.ipify.org?format=json`);
    //     //     return response.data.ip;
    //     // } catch (error) {
    //     //     try {
    //     //         const response2 = await api.get(`https://geolocation-db.com/json/`);
    //     //         return response2.data.IPv4;
    //     //     } catch (error) {
    //     //         return "";
    //     //     }
    //     // }
    //     try {
    //         const response2 = await api.get(`https://geolocation-db.com/json/`);
    //         return response2.data.IPv4;
    //     } catch (error) {
    //         return "";
    //     }
    // };

    static getTipodeConta = async () => {
        const response = await api.get(`/sysTipoConta?Page=${1}&RecordsPerPage=${100}&Search=${''}`);
        return response.data;
    };
    static getTipodeContato = async () => {
        const response = await api.get(`/sysTipoContato?Page=${1}&RecordsPerPage=${100}&Search=${''}`);
        return response.data;
    };
    static getTipodeDocumento = async () => {
        const response = await api.get(`/sysTipoDocumento?Page=${1}&RecordsPerPage=${100}&Search=${''}`);
        return response.data;
    };
    static getTransacoesModoPagamento = async () => {
        const response = await api.get(`/sysTransacaoModoPgto?Page=${1}&RecordsPerPage=${100}`);
        return response.data;
    };
    static getTransacoesStatus = async () => {
        const response = await api.get(`/sysTransacaoStatus?Page=${1}&RecordsPerPage=${100}`);
        return response.data;
    };
    static getBandeiras = async (page: number, recordsPerPage: number, search: string) => {
        const response = await api.get(`/Bandeira?Page=${page}&RecordsPerPage=${recordsPerPage}&Search=${search}`);
        return response.data;
    };
    static getTipoServico = async () => {
        const response = await api.get(`sysTipoServico?Page=${1}&RecordsPerPage=${100}`);
        return response.data;
    };
    static getServicoStatus = async () => {
        const response = await api.get(`sysServicoStatus?Page=${1}&RecordsPerPage=${100}`);
        return response.data;
    };
    static getRealTime = async (
        idCliente: number,
        id: string | null,
        dataInicio: number, 
        dataFim: number,
        limit: number,   
        page: number    
      ) => {
      
        const url = `/transacaozoop/realtime/zoop?idCliente=${idCliente}${id ? `&id=${id}` : ''}&date_range_gte=${dataInicio}&date_range_lte=${dataFim}&limit=${limit}&page=${page}`;
        
        const response = await api.get(url);
        return response.data;
      };
};

